module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"filter":"Filter:","categories":"Kategorien","states":"Stati"},"fr":{},"en":{}}')
  delete Component.options._Ctor
}
